/* ==========================================================================
   SWAY URBAN - Interactions (v14)  |  by Sewool
   Self-contained, no dependencies. v14: native scrolling + native cursor (Mac fix).
   ========================================================================== */
(function () {
  "use strict";

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fine = window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  var WA_PHONE = "919654293365"; // Sway Urban WhatsApp
  var SHIP_THRESHOLD = 999;       // Rs - free shipping threshold
  var DISCOUNT_CODE = "SWAY10";

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function isProduct() { return !!$('main[data-template="product"]') || (/\/products\//.test(location.pathname) && !!$("product-info, .product__info-container")); }

  /* ---- Toasts (global helper) ------------------------------------------ */
  function toastWrap() {
    var w = $(".su-toast-wrap");
    if (!w) { w = document.createElement("div"); w.className = "su-toast-wrap"; document.body.appendChild(w); }
    return w;
  }
  window.suToast = function (msg) {
    var w = toastWrap(), t = document.createElement("div");
    t.className = "su-toast"; t.innerHTML = msg; w.appendChild(t);
    requestAnimationFrame(function () { t.classList.add("su-show"); });
    setTimeout(function () { t.classList.remove("su-show"); setTimeout(function () { t.remove(); }, 400); }, 2600);
  };

  /* ---- 1. Scroll reveal ------------------------------------------------- */
  function enhanceReveal() {
    $$(".card-wrapper, .su-rcard, .su-usp__item, .sm-card, .su-cat, .su-look__tile").forEach(function (el, i) {
      if (!el.classList.contains("su-reveal") && !el.classList.contains("su-in")) el.classList.add("su-reveal", "su-delay-" + (i % 3));
    });
  }
  function initReveal() {
    var els = $$(".su-reveal:not(.su-in)");
    if (!els.length) return;
    if (reduce || !("IntersectionObserver" in window)) { els.forEach(function (el) { el.classList.add("su-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("su-in"); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: "0px 0px -6% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- 2. Marquee + review scroller: duplicate track for seamless loop --- */
  function initMarquee() {
    $$(".su-marquee__track, .su-revscroll__track").forEach(function (track) {
      if (track.dataset.suCloned) return;
      track.innerHTML = track.innerHTML + track.innerHTML;
      track.dataset.suCloned = "1";
    });
  }

  /* ---- 3. Countdown ----------------------------------------------------- */
  function pad(n) { return n < 10 ? "0" + n : "" + n; }
  function initCountdowns() {
    $$("[data-su-countdown]").forEach(function (t) {
      if (t.dataset.suInit) return; t.dataset.suInit = "1";
      var mode = t.getAttribute("data-su-mode") || "daily", target;
      function recompute() { var now = new Date(), end = new Date(now); end.setHours(23, 59, 59, 0); if (end <= now) end.setDate(end.getDate() + 1); return end.getTime(); }
      if (mode === "daily") target = recompute();
      else { var raw = t.getAttribute("data-su-date"), p = raw ? new Date(raw.replace(" ", "T")) : NaN; target = isNaN(p) ? Date.now() + 864e5 : p.getTime(); }
      var u = { d: $('[data-u="d"]', t), h: $('[data-u="h"]', t), m: $('[data-u="m"]', t), s: $('[data-u="s"]', t) };
      function set(el, v) { if (!el) return; var s = pad(v); if (el.textContent !== s) { el.textContent = s; if (!reduce) { el.classList.remove("su-tick"); void el.offsetWidth; el.classList.add("su-tick"); } } }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) { if (mode === "daily") { target = recompute(); diff = target - Date.now(); } else diff = 0; }
        var s = Math.floor(diff / 1000);
        set(u.d, Math.floor(s / 86400)); set(u.h, Math.floor((s % 86400) / 3600)); set(u.m, Math.floor((s % 3600) / 60)); set(u.s, s % 60);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---- 4. 3D tilt --------------------------------------------------------- */
  function initTilt() {
    if (reduce || !fine) return;
    $$(".su-tilt").forEach(function (el) {
      if (el.dataset.suTilt) return; el.dataset.suTilt = "1";
      var max = parseFloat(el.getAttribute("data-tilt")) || 8, area = el.closest("[data-tilt-area]") || el;
      area.addEventListener("mousemove", function (e) {
        var r = el.getBoundingClientRect(), px = (e.clientX - r.left) / r.width - .5, py = (e.clientY - r.top) / r.height - .5;
        el.style.transform = "perspective(900px) rotateY(" + (px * max).toFixed(2) + "deg) rotateX(" + (-py * max).toFixed(2) + "deg)";
      });
      area.addEventListener("mouseleave", function () { el.style.transform = ""; });
    });
  }

  /* ---- 5. Hero headline word reveal ------------------------------------- */
  function initHeroReveal() {
    var t = $(".su-hero__title"); if (!t || t.dataset.suDone) return; t.dataset.suDone = "1";
    var tmp = document.createElement("div"); tmp.innerHTML = t.innerHTML; var out = "";
    Array.prototype.forEach.call(tmp.childNodes, function (n) {
      if (n.nodeType === 3) n.textContent.split(/(\s+)/).forEach(function (w) { out += w.trim() ? '<span class="su-word"><span>' + w + "</span></span>" : w; });
      else out += '<span class="su-word"><span>' + n.outerHTML + "</span></span>";
    });
    t.innerHTML = out;
  }

  /* ---- 6. Sticky add-to-cart (product pages) ----------------------------- */
  function initStickyATC() {
    if (!isProduct() || $(".su-sticky-atc")) return;
    var form = $('product-form form, form[action*="/cart/add"]'), submit = form && $('[type="submit"], .product-form__submit', form);
    if (!form || !submit) return;
    var titleEl = $(".product__title h1, .product__title, h1"), priceEl = $(".price .price-item--sale, .price .price-item--regular, .price-item");
    var bar = document.createElement("div"); bar.className = "su-sticky-atc";
    bar.innerHTML = '<div class="su-sticky-atc__info"><div class="su-sticky-atc__title">' + (titleEl ? titleEl.textContent.trim() : "Add to cart") + '</div><div class="su-sticky-atc__price">' + (priceEl ? priceEl.textContent.trim() : "") + '</div></div><button type="button" class="su-sticky-atc__btn">Add to cart</button>';
    document.body.appendChild(bar);
    $(".su-sticky-atc__btn", bar).addEventListener("click", function () { submit.click(); });
    var priceBox = $(".price");
    if (priceBox && "MutationObserver" in window) new MutationObserver(function () { var p = $(".price-item--sale, .price-item--regular, .price-item", priceBox); if (p) $(".su-sticky-atc__price", bar).textContent = p.textContent.trim(); }).observe(priceBox, { subtree: true, childList: true, characterData: true });
    var anchor = submit;
    var ticking = false;
    function sync() { ticking = false; bar.classList.toggle("su-show", anchor.getBoundingClientRect().bottom < 0); }
    window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(sync); } }, { passive: true });
    sync();
  }

  /* ---- 7. Product extras: size chart modal + delivery + urgency --------- */
  function initProductExtras() {
    if (!isProduct()) return;
    var anchor = $(".product-form") || $(".product__info-container .price") || $(".product__info-container");
    if (!anchor) return;
    var scBody = $(".su-sizesec__body");
    if (!$(".su-sizebtn") && scBody) {
      var btn = document.createElement("button"); btn.type = "button"; btn.className = "su-sizebtn"; btn.innerHTML = "&#128207; Size Chart";
      var modal = document.createElement("div"); modal.className = "su-modal"; modal.setAttribute("role", "dialog"); modal.setAttribute("aria-label", "Size chart");
      var note = $(".su-sizesec .note");
      modal.innerHTML = '<div class="su-modal__box"><button class="su-modal__x" aria-label="Close">&times;</button><h3>Size Chart</h3>' +
        scBody.innerHTML + (note ? '<p style="margin-top:14px;font-size:13px;opacity:.7;">' + note.innerHTML + "</p>" : "") + "</div>";
      document.body.appendChild(modal);
      btn.addEventListener("click", function () { modal.classList.add("su-open"); });
      modal.addEventListener("click", function (e) { if (e.target === modal || e.target.classList.contains("su-modal__x")) modal.classList.remove("su-open"); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") modal.classList.remove("su-open"); });
      anchor.parentNode.insertBefore(btn, anchor);
    }
    if (!$(".su-deliv")) {
      var wrap = document.createElement("div"), d = new Date(); d.setDate(d.getDate() + 5);
      var by = d.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" });
      wrap.innerHTML = '<div class="su-urgency">Dispatches within 24-48 hours</div><div class="su-deliv">&#128666; Order now &mdash; estimated delivery by <b>' + by + "</b></div>" + '<ul class="su-assure"><li>Cash on Delivery available</li><li>Easy 7-day returns &amp; size exchange</li><li>Free shipping above &#8377;999</li><li>100% secure checkout</li></ul><div class="su-fitnote"><b>Fit guide:</b> Unisex oversized fit &mdash; pick your usual size for the relaxed oversized look, or go one size down for a regular fit.</div><style>.su-assure{list-style:none;margin:12px 0 0;padding:12px 14px;display:grid;grid-template-columns:1fr 1fr;gap:8px 14px;background:#f7f7f7;border-radius:6px;font-size:13px;line-height:1.35;color:#141414}.su-assure li{position:relative;padding-left:20px}.su-assure li:before{content:"\\2713";position:absolute;left:0;top:0;color:#e9612b;font-weight:800}.su-fitnote{margin:10px 0 0;font-size:13px;line-height:1.45;opacity:.85}@media (max-width:480px){.su-assure{grid-template-columns:1fr}}</style>';
      var after = $(".swl-wa-wrap") || anchor;
      after.parentNode.insertBefore(wrap, after.nextSibling);
    }
  }

  /* ---- 8. Free-shipping progress bar ------------------------------------ */
  function initShipBar() {
    var header = $("sticky-header, .header-wrapper, header"); if (!header || $(".su-ship")) return;
    var bar = document.createElement("div"); bar.className = "su-ship"; bar.style.display = "none";
    header.parentNode.insertBefore(bar, header.nextSibling);
    function render(cart) {
      var total = (cart.total_price || 0) / 100;
      if (!cart.item_count) { bar.style.display = "none"; return; }
      bar.style.display = "block";
      if (total >= SHIP_THRESHOLD) bar.innerHTML = "&#127881; You&#39;ve unlocked <b>FREE shipping!</b>";
      else bar.innerHTML = "Add <b>&#8377;" + Math.ceil(SHIP_THRESHOLD - total) + "</b> more for FREE shipping<div class=\"su-ship__track\"><div class=\"su-ship__fill\" style=\"width:" + Math.min(100, total / SHIP_THRESHOLD * 100) + "%\"></div></div>";
    }
    function fetchCart() { fetch("/cart.js").then(function (r) { return r.json(); }).then(render).catch(function () {}); }
    fetchCart();
    document.addEventListener("cart:updated", fetchCart); document.addEventListener("cart:refresh", fetchCart);
    document.addEventListener("click", function (e) { if (e.target.closest('[name="add"], .product-form__submit, .quick-add__submit, .cart-remove-button, .quantity__button')) setTimeout(fetchCart, 1000); });
  }

  /* ---- 9. Discount popup (corner X, ESC, outside click, once/session) ---- */
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function initExitPopup() {
    // v14: no exit-intent trigger (on Mac it fired every time the mouse went to the tabs and blurred the page)
    if ($(".su-pop") || isProduct() || /^\/(cart|checkout|account)/.test(location.pathname)) return;
    var last = parseInt(store("su_pop_ts") || "0", 10);
    if (last && Date.now() - last < 7 * 864e5) return;
    var pop = document.createElement("div"); pop.className = "su-pop"; pop.setAttribute("role", "dialog"); pop.setAttribute("aria-label", "Discount offer");
    pop.innerHTML =
      '<div class="su-pop__box">' +
        '<button type="button" class="su-pop__x" aria-label="Close">&times;</button>' +
        '<div class="su-pop__tag">Limited Offer</div>' +
        '<h3 class="su-pop__h">Unlock <span>10% Off</span></h3>' +
        '<p class="su-pop__p">Join the Sway Urban list and get 10% off your first order.</p>' +
        '<div class="su-pop__code"><span>' + DISCOUNT_CODE + '</span><button type="button" class="su-pop__copy">Copy</button></div>' +
        '<button type="button" class="su-pop__go">Claim My Discount</button>' +
        '<div class="su-pop__fine">Use the code at checkout.</div>' +
      "</div>";
    document.body.appendChild(pop);
    var shown = false;
    function close() { pop.classList.remove("su-open"); }
    function show() { if (shown) return; shown = true; store("su_pop_ts", String(Date.now())); pop.classList.add("su-open"); }
    function copy() { try { navigator.clipboard.writeText(DISCOUNT_CODE); } catch (e) {} window.suToast("Code <b>" + DISCOUNT_CODE + "</b> copied"); }
    pop.addEventListener("click", function (e) {
      if (e.target.closest(".su-pop__x")) return close();
      if (e.target.closest(".su-pop__copy")) { copy(); e.target.textContent = "Copied!"; }
      if (e.target.closest(".su-pop__go")) { copy(); close(); window.location.href = "/collections/all"; }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
    setTimeout(show, 25000);
    window.addEventListener("scroll", function onS() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > 0.55) { window.removeEventListener("scroll", onS); show(); }
    }, { passive: true });
  }

  /* ---- 10. Wishlist (localStorage) --------------------------------------- */
  var HEART = '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.9-10-9.2C.4 8.9 1.6 5.5 4.8 5.1 6.8 4.9 8.4 6 12 8.5c3.6-2.5 5.2-3.6 7.2-3.4 3.2.4 4.4 3.8 2.8 6.7C19.5 16.1 12 21 12 21z"/></svg>';
  function wishGet() { try { return JSON.parse(localStorage.getItem("su_wish") || "[]"); } catch (e) { return []; } }
  function wishSave(a) { try { localStorage.setItem("su_wish", JSON.stringify(a)); } catch (e) {} document.dispatchEvent(new Event("su:wish")); }
  window.suWishToggle = function (url, btn, onCls) {
    var arr = wishGet(), i = arr.indexOf(url);
    if (i > -1) { arr.splice(i, 1); btn.classList.remove(onCls); window.suToast("Removed from wishlist"); }
    else { arr.push(url); btn.classList.add(onCls); window.suToast("&#10084; Saved to wishlist"); }
    wishSave(arr);
  };
  function initWishlist() {
    var list = wishGet();
    $$(".card-wrapper, .card").forEach(function (card) {
      if ($(".su-wish-btn", card)) return;
      var link = $("a[href*='/products/']", card); if (!link) return;
      var url = link.getAttribute("href").split("?")[0];
      var media = $(".card__media, .media", card) || card;
      if (getComputedStyle(media).position === "static") media.style.position = "relative";
      var b = document.createElement("button"); b.type = "button"; b.className = "su-wish-btn"; b.setAttribute("aria-label", "Add to wishlist"); b.innerHTML = HEART;
      if (list.indexOf(url) > -1) b.classList.add("su-active");
      b.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); window.suWishToggle(url, b, "su-active"); });
      media.appendChild(b);
    });
    var cartIcon = $("#cart-icon-bubble, a[href='/cart'], .header__icon--cart");
    if (cartIcon && !$(".su-wish-count-wrap")) {
      var span = document.createElement("span"); span.className = "su-wish-count-wrap";
      function upd() { var n = wishGet().length; span.innerHTML = n ? '<span class="su-wish-count" title="Wishlist">' + n + "</span>" : ""; }
      document.addEventListener("su:wish", upd); upd(); cartIcon.parentNode.insertBefore(span, cartIcon);
    }
  }

  /* ---- 11. Endless scroll: More Styles (product pages) ------------------ */
  function initMoreProducts() {
    var box = $("#su-more"); if (!box || box.dataset.suInit) return; box.dataset.suInit = "1";
    var handle = box.getAttribute("data-handle") || "all", grid = $(".su-more__grid", box), sent = $(".su-more__sentinel", box), load = $(".su-more__loading", box);
    var page = 1, done = false, busy = false, seen = {}, self = (location.pathname.split("?")[0] || "");
    function txt(el) { return el ? el.textContent.replace(/\s+/g, " ").trim() : ""; }
    function skeleton(on) { $$(".su-skel-wrap", box).forEach(function (s) { s.remove(); }); if (!on) return; for (var i = 0; i < 3; i++) { var s = document.createElement("div"); s.className = "su-skel-wrap"; s.innerHTML = '<div class="su-skel"></div><div class="su-skel-line"></div>'; grid.appendChild(s); } }
    function go() {
      if (busy || done) return; busy = true; skeleton(true); if (load) load.style.display = "block";
      fetch("/collections/" + handle + "?page=" + page).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html"), cards = doc.querySelectorAll(".grid__item, li.grid__item, .card-wrapper"), added = 0, list = wishGet();
        skeleton(false);
        cards.forEach(function (c) {
          var a = c.querySelector('a[href*="/products/"]'); if (!a) return;
          var href = a.getAttribute("href").split("?")[0]; if (seen[href] || href.indexOf(self) === 0 && self.indexOf("/products/") === 0) return; seen[href] = 1;
          var img = c.querySelector("img"), src = "";
          if (img) { src = img.getAttribute("src") || ""; if (!src || src.indexOf("data:") === 0) { var ss = img.getAttribute("srcset") || img.getAttribute("data-srcset") || ""; src = (ss.split(",")[0] || "").trim().split(" ")[0] || img.getAttribute("data-src") || ""; } }
          if (src.indexOf("//") === 0) src = "https:" + src;
          var title = txt(c.querySelector(".card__heading, .card-information__text, h3")) || txt(a);
          var pr = c.querySelector(".price"), onSale = !!(pr && pr.classList.contains("price--on-sale"));
          var sale = onSale ? txt(c.querySelector(".price__sale .price-item--sale")) : "", comp = onSale ? txt(c.querySelector(".price__sale .price-item--regular")) : "", reg = txt(c.querySelector(".price__regular .price-item--regular"));
          var priceHtml = onSale && sale ? "<s>" + comp + "</s><b>" + sale + "</b>" : "<b>" + (reg || sale) + "</b>";
          var el = document.createElement("a"); el.className = "sm-card su-reveal"; el.href = href;
          el.innerHTML = '<div class="sm-card__img">' + (src ? '<img src="' + src + '" alt="' + title.replace(/"/g, "") + '" loading="lazy">' : "") + (onSale ? '<span class="sm-badge">Sale</span>' : "") + '<button type="button" class="sm-wish' + (list.indexOf(href) > -1 ? " on" : "") + '" aria-label="Wishlist">' + HEART + "</button></div><div class=\"sm-card__t\">" + title + "</div><div class=\"sm-card__p\">" + priceHtml + "</div>";
          $(".sm-wish", el).addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); window.suWishToggle(href, this, "on"); });
          grid.appendChild(el); added++;
        });
        if (added === 0) done = true; else page++;
        busy = false; if (load) load.style.display = "none"; initReveal();
      }).catch(function () { skeleton(false); done = true; busy = false; if (load) load.style.display = "none"; });
    }
    if ("IntersectionObserver" in window && sent) new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) go(); }); }, { rootMargin: "500px" }).observe(sent);
    go();
  }

  /* ---- 12. Custom-card wishlist hearts (sm-cards rendered by Liquid) ---- */
  function initSmWish() {
    var list = wishGet();
    $$(".sm-card").forEach(function (card) {
      if ($(".sm-wish", card) || !card.getAttribute("href")) return;
      var href = card.getAttribute("href").split("?")[0], img = $(".sm-card__img", card); if (!img) return;
      var b = document.createElement("button"); b.type = "button"; b.className = "sm-wish" + (list.indexOf(href) > -1 ? " on" : ""); b.setAttribute("aria-label", "Wishlist"); b.innerHTML = HEART;
      b.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); window.suWishToggle(href, b, "on"); });
      img.appendChild(b);
    });
  }

  /* ---- 13. Empty collection fallback flag ------------------------------- */
  function initEmptyCollection() { if ($(".su-empty")) document.body.classList.add("su-has-empty"); }

  /* ---- 14. Floating WhatsApp + back-to-top ------------------------------ */
  function initFloating() {
    if (!$(".su-wa")) {
      var a = document.createElement("a"); a.className = "su-wa"; a.href = "https://wa.me/" + WA_PHONE + "?text=" + encodeURIComponent("Hi Sway Urban! I'm interested in your products."); a.target = "_blank"; a.rel = "noopener"; a.setAttribute("aria-label", "Chat on WhatsApp");
      a.innerHTML = '<svg viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.003 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.59 4.46 1.712 6.403L3.2 28.8l6.57-1.723a12.74 12.74 0 0 0 6.233 1.59h.005c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.332-6.635-3.75-9.052A12.71 12.71 0 0 0 16.003 3.2zm0 23.36h-.004a10.6 10.6 0 0 1-5.4-1.48l-.387-.23-4.003 1.05 1.068-3.9-.252-.4a10.56 10.56 0 0 1-1.62-5.6c0-5.868 4.774-10.64 10.64-10.64a10.57 10.57 0 0 1 7.52 3.118 10.57 10.57 0 0 1 3.115 7.526c0 5.867-4.773 10.64-10.64 10.64zm5.834-7.968c-.32-.16-1.892-.933-2.185-1.04-.293-.107-.507-.16-.72.16-.213.32-.826 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.572-1.587-.95-.848-1.593-1.895-1.78-2.215-.187-.32-.02-.492.14-.652.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.735-.987-2.375-.26-.624-.524-.54-.72-.55l-.613-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.093-1.12 2.667 0 1.573 1.147 3.093 1.307 3.307.16.213 2.253 3.44 5.46 4.827.763.33 1.36.527 1.824.674.767.244 1.464.21 2.016.127.615-.092 1.892-.773 2.16-1.52.267-.747.267-1.387.187-1.52-.08-.133-.293-.213-.613-.373z"/></svg>';
      document.body.appendChild(a);
    }
    if (!$(".su-top")) {
      var btn = document.createElement("button"); btn.type = "button"; btn.className = "su-top"; btn.setAttribute("aria-label", "Back to top");
      btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
      document.body.appendChild(btn);
      btn.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" }); });
      var toggle = function () { btn.classList.toggle("su-show", window.scrollY > 600); };
      window.addEventListener("scroll", toggle, { passive: true }); toggle();
    }
  }

  /* ---- 15. Motion layer: progress, intro, magnetic, header ---------------- */
  function initProgress() {
    if ($(".su-progress")) return;
    var bar = document.createElement("div"); bar.className = "su-progress"; document.body.appendChild(bar);
    function upd() { var h = document.documentElement.scrollHeight - window.innerHeight; bar.style.width = (h > 0 ? window.scrollY / h * 100 : 0) + "%"; }
    window.addEventListener("scroll", upd, { passive: true }); upd();
  }
  function initIntro() {
    var seen = null; try { seen = sessionStorage.getItem("su_intro"); sessionStorage.setItem("su_intro", "1"); } catch (e) { seen = "1"; }
    if (reduce || seen || $(".su-intro")) return;
    var el = document.createElement("div"); el.className = "su-intro"; el.innerHTML = '<div class="su-intro__logo"><span>SWAY</span> <span>URBAN</span></div>'; document.body.appendChild(el);
    setTimeout(function () { el.classList.add("su-gone"); }, 1100); setTimeout(function () { el.remove(); }, 2000);
  }
  function initMagnetic() {
    if (!fine || reduce) return;
    $$(".su-btn").forEach(function (b) {
      if (b.dataset.suMag) return; b.dataset.suMag = "1";
      b.addEventListener("mousemove", function (e) { var r = b.getBoundingClientRect(); b.style.transform = "translate(" + (e.clientX - r.left - r.width / 2) * .22 + "px," + (e.clientY - r.top - r.height / 2) * .3 + "px)"; });
      b.addEventListener("mouseleave", function () { b.style.transform = ""; });
    });
  }
  function initHeaderScroll() { window.addEventListener("scroll", function () { document.body.classList.toggle("su-scrolled", window.scrollY > 40); }, { passive: true }); }

  /* ---- 16. Add-to-cart: fly image to cart + bump + toast ---------------- */
  function initAtcFly() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest('.product-form__submit, [name="add"], .quick-add__submit'); if (!btn) return;
      var cart = $("#cart-icon-bubble, .header__icon--cart");
      var scope = btn.closest(".card, .product, .grid__item, main") || document, img = $(".card__media img, .product__media img, img", scope);
      if (cart && img) {
        var ir = img.getBoundingClientRect(), cr = cart.getBoundingClientRect(), fly = img.cloneNode(true); fly.className = "su-fly";
        fly.style.left = ir.left + "px"; fly.style.top = ir.top + "px"; fly.style.width = ir.width + "px"; fly.style.height = ir.height + "px"; document.body.appendChild(fly);
        requestAnimationFrame(function () { fly.style.left = cr.left + cr.width / 2 + "px"; fly.style.top = cr.top + cr.height / 2 + "px"; fly.style.width = "24px"; fly.style.height = "24px"; fly.style.opacity = "0.2"; });
        setTimeout(function () { fly.remove(); cart.classList.add("su-cart-bump"); setTimeout(function () { cart.classList.remove("su-cart-bump"); }, 400); }, 850);
      }
      if (!btn.closest(".quick-add__submit") || !$(".quick-add-modal")) setTimeout(function () { window.suToast("&#10004; Added to cart"); }, 500);
    });
  }

  /* ---- 23. Hero motion: pointer parallax + scroll-linked drift ---------- */
  function initHeroMotion() {
    var hero = $(".su-hero");
    if (!hero || hero.dataset.suMotion) return;
    hero.dataset.suMotion = "1";
    if (reduce) return;
    var tees = $$(".su-tee", hero);
    if (!tees.length) return;

    // depth factor per garment: the further out, the more it travels
    tees.forEach(function (t, i) { t.dataset.depth = (i % 2 === 0 ? -1 : 1) * (14 + i * 4); });

    var mx = 0, my = 0, tx = 0, ty = 0, sy = 0, raf = null, tracking = false;

    function apply() {
      raf = null;
      tees.forEach(function (t) {
        var d = parseFloat(t.dataset.depth) || 12;
        // pointer parallax + outward drift & sink as the hero scrolls away
        var px = tx * d;
        var py = ty * d * 0.6 + sy * 26;
        var out = sy * (d < 0 ? -34 : 34);
        t.style.setProperty("--su-x", (px + out).toFixed(1) + "px");
        t.style.setProperty("--su-y", py.toFixed(1) + "px");
        t.style.setProperty("--su-sc", (1 + sy * 0.05).toFixed(3));
      });
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(apply); }

    if (fine) {
      hero.addEventListener("mousemove", function (e) {
        var r = hero.getBoundingClientRect();
        mx = (e.clientX - r.left) / r.width - 0.5;
        my = (e.clientY - r.top) / r.height - 0.5;
        if (!tracking) { tracking = true; hero.classList.add("su-track"); }
        tx = mx; ty = my; schedule();
      });
      hero.addEventListener("mouseleave", function () {
        tracking = false; hero.classList.remove("su-track");
        tx = 0; ty = 0; schedule();
      });
    }
    window.addEventListener("scroll", function () {
      var h = hero.offsetHeight || 1;
      sy = Math.min(1, Math.max(0, window.scrollY / h));
      schedule();
    }, { passive: true });
    apply();
  }

  /* ---- init ---------------------------------------------------------------- */
  function init() {
    var steps = [initIntro, initProgress, initHeaderScroll, initAtcFly, initHeroReveal, enhanceReveal, initReveal,
      initMarquee, initCountdowns, initTilt, initMagnetic, initStickyATC, initProductExtras, initShipBar, initExitPopup, initWishlist,
      initSmWish, initMoreProducts, initEmptyCollection, initFloating, initHeroMotion];
    steps.forEach(function (f) { try { f(); } catch (e) { if (window.console) console.warn("SU:", f.name, e); } });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", function () {
    [initHeroReveal, enhanceReveal, initReveal, initMarquee, initCountdowns, initTilt, initMagnetic, initWishlist, initSmWish, initHeroMotion].forEach(function (f) { try { f(); } catch (e) {} });
  });
})();
